import State from '../interfaces/states/State';

import { createSelector } from 'reselect';

const getUserAvatar = createSelector(
  (state: State) => state.findUser.userInfo,
  (userInfo): string[] => {
    // @ts-ignore
    if (userInfo.data) {
      // @ts-ignore
      return userInfo.data.map(item => item.avatar);
    } else {
      return null;
    }
  }
);

export default getUserAvatar;
